module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.reviewObj) ? _c('div', {
    staticClass: "brand-review-wrapper"
  }, [_c('div', {
    staticClass: "box brand-review",
    class: _vm.isNew ? 'new-brand-review' : ''
  }, [(!_vm.isNew) ? _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBrandReview(_vm.review.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Имя"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.reviewObj.name),
      callback: function($$v) {
        _vm.$set(_vm.reviewObj, "name", $$v)
      },
      expression: "reviewObj.name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Компания"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.reviewObj.company),
      callback: function($$v) {
        _vm.$set(_vm.reviewObj, "company", $$v)
      },
      expression: "reviewObj.company"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Текст"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.reviewObj.text),
      callback: function($$v) {
        _vm.$set(_vm.reviewObj, "text", $$v)
      },
      expression: "reviewObj.text"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Видео"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.reviewObj.videoUrl),
      callback: function($$v) {
        _vm.$set(_vm.reviewObj, "videoUrl", $$v)
      },
      expression: "reviewObj.videoUrl"
    }
  })], 1), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.reviewObj.isPublished),
      callback: function($$v) {
        _vm.$set(_vm.reviewObj, "isPublished", $$v)
      },
      expression: "reviewObj.isPublished"
    }
  }, [_vm._v("Опубликовать отзыв")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.reviewObj.fullReview || _vm.file) ? _c('div', {
    staticClass: "link-wrapper"
  }, [_c('a', {
    staticClass: "link mt-10",
    attrs: {
      "href": '/' + _vm.reviewObj.fullReview,
      "target": "_blank"
    }
  }, [_vm._v("Просмотреть полный отзыв")]), _vm._v(" "), _c('span', {
    staticClass: "delete-file",
    on: {
      "click": _vm.deleteFile
    }
  }, [_vm._v("x")])]) : _c('b-field', {
    staticClass: "mt-10"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.$refs.loadReviewFile.click()
      }
    }
  }, [_vm._v("\n        Загрузить полный отзыв\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "loadReviewFile",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadReviewFile
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary mt-10 save-button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a324dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrandReviewItem.vue
// module id = 949
// module chunks = 0